/**
 * 后端能力开关（GET /api/v1/features）：下线或可选功能是否开放，前端按它隐藏入口（任务 37：ChatBI V3 下线）。
 * 读一次缓存整页会话；接口不通（旧版后端没有这个接口）时按开放处理，保持原样。
 */
import apiClient from './index'

export interface Features {
  /** ChatBI V3：「数据分析智能体」「仪表板生成」 */
  chatbi_v3: boolean
}

export type FeatureKey = keyof Features

const OPEN: Features = { chatbi_v3: true }
let cached: Promise<Features> | null = null

export function getFeatures(): Promise<Features> {
  if (!cached) {
    cached = apiClient
      .get<Partial<Features>>('/features')
      .then(data => ({ ...OPEN, ...(data || {}) }))
      .catch(() => {
        cached = null // 下次导航再试
        return { ...OPEN }
      })
  }
  return cached
}

/** 测试用：清掉缓存 */
export function resetFeaturesCache(): void {
  cached = null
}
